import {
  Abwesenheitsgrund,
  Markierung,
  Mitarbeiter,
} from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import dayjs from 'dayjs';

export class Abwesenheitsantraege {
  constructor({
    id,
    mitarbeiter,
    grund,
    von,
    bis,
    markierung,
  }: {
    id: string;
    grund: Abwesenheitsgrund;
    mitarbeiter: Mitarbeiter;
    von: dayjs.Dayjs;
    bis: dayjs.Dayjs;
    markierung: Markierung;
  }) {
    this.grund = grund;
    this.id = id;
    this.mitarbeiter = mitarbeiter;
    this.von = von;
    this.bis = bis;
    this.markierung = markierung;
  }

  id: string;
  grund: Abwesenheitsgrund;
  von: dayjs.Dayjs;
  bis: dayjs.Dayjs;
  markierung: Markierung;
  mitarbeiter: Mitarbeiter;
}
